import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"

export default class extends Controller {
	static targets = ["cover", "instructions", "connection", "social", "legal"]

	connect() {
		gsap.fromTo(
			this.coverTarget,
			{ opacity: 0 },
			{
				opacity: 1,
				duration: 3,
				delay: 0.25,
				ease: "power4.out"
			}
		)

		gsap.fromTo(
			this.instructionsTarget,
			{ opacity: 0 },
			{
				opacity: 1,
				duration: 3,
				delay: 0.75,
				ease: "power4.out"
			}
		)

		gsap.fromTo(
			this.connectionTargets,
			{ opacity: 0 },
			{
				opacity: 1,
				duration: 3,
				delay: 1,
				stagger: 0.25,
				ease: "power4.out"
			}
		)

		gsap.fromTo(
			this.socialTargets,
			{ opacity: 0 },
			{
				opacity: 1,
				duration: 3,
				delay: 1.25,
				stagger: 0.25,
				ease: "power4.out"
			}
		)

		gsap.fromTo(
			this.legalTargets,
			{ opacity: 0 },
			{
				opacity: 1,
				duration: 3,
				delay: 1.75,
				stagger: 0.25,
				ease: "power4.out"
			}
		)
	}
}
